import {
    userLoggedIn,
    sendInitializedNotification,
    handleNewCall,
    handleCtiClick,
    ctiCallInfoFromActiveCall,
} from 'flow/actions/cti-actions';
import { isAppCti } from 'flow/utils/app-utils';
import Actions from 'flow/actions';
import { addCtiLogEntry } from 'flow/utils/browser-utils';
import {
    registerInstance,
    unregisterInstance,
} from 'flow/utils/instance-count-utils';
import { getFocusedActiveCall } from 'flow/selectors/call-selectors';
import {
    CTI_SETTINGS_OPEN_ON_CALL,
    getCtiSetting,
} from 'flow/utils/cti-settings-utils';
import { segmentTrack } from 'flow/actions/segment-actions';

export const ctiMiddleware = (store) => (next) => (action) => {
    const { dispatch, getState } = store;
    const isEmbeddedIntegration = isAppCti(getState());

    if (isEmbeddedIntegration) {
        switch (action.type) {
            case Actions.CTI_USER_LOGGED_OUT: {
                unregisterInstance();
                break;
            }
            case Actions.CTI_USER_LOGGED_IN: {
                registerInstance();
                break;
            }
        }

        // Don't mix this logic with the other switch statements since these
        // cases are quite specific and utilizes an unusual fallthrough.
        switch (action.type) {
            case Actions.CTI_USER_LOGGED_OUT:
            case Actions.CTI_USER_LOGGED_IN: {
                const { integration } = getState();
                const loggedIn = integration.get('loggedIn');

                if (loggedIn === null) {
                    const isLoggedIn =
                        action.type === Actions.CTI_USER_LOGGED_IN;
                    addCtiLogEntry(
                        `First notion of login status recieved, start sending init notification with status isLoggedIn: ${isLoggedIn}.`,
                    );
                    dispatch(sendInitializedNotification(isLoggedIn));
                }
                break;
            }
        }
    }

    const result = next(action);

    if (isEmbeddedIntegration) {
        switch (action.type) {
            case Actions.CTI_RESULT_CONTACT_DECORATIONS: {
                //Open Contact on incoming call
                //check if is active call
                const focusedActiveCall = getFocusedActiveCall(getState());
                if (!focusedActiveCall) {
                    break;
                }
                const ctiSetting = getCtiSetting(getState());
                if (!ctiSetting) {
                    break;
                }
                const contactNumber = Object.keys(action.data.contacts)[0];
                const contact = action.data.contacts[contactNumber][0];
                const routeFlow = contact && contact.routeFlow; //Redirect route
                const openOnCall = ctiSetting.openOnCall?.value;

                const {
                    localNumber,
                    remoteNumber: number,
                    direction,
                } = ctiCallInfoFromActiveCall(focusedActiveCall, getState());

                switch (openOnCall) {
                    case CTI_SETTINGS_OPEN_ON_CALL.OPEN_CONTACT:
                        if (routeFlow) {
                            dispatch(
                                handleCtiClick(routeFlow, localNumber, {
                                    direction,
                                    number,
                                }),
                            );
                        }
                        break;
                    case CTI_SETTINGS_OPEN_ON_CALL.OFF:
                    default:
                        // do nothing
                        break;
                }
                break;
            }
            case Actions.PHONE_NEW_UA: {
                dispatch(userLoggedIn());
                break;
            }
            case Actions.CTI_REGISTER_ORIGIN: {
                const { data } = action;

                if (data?.host?.version) {
                    dispatch(
                        segmentTrack('[CTI] Report cti host version', {
                            version: data.host.version,
                        }),
                    );
                }

                // If the wrapper registration comes after the user has
                // gotten their user agent, the previously dispatched
                // login message was lost and we need to resend one now.
                const { phone } = getState();
                const userAgent = phone.get('userAgent');
                if (userAgent) {
                    dispatch(userLoggedIn());
                }

                // It is possible for the CTI to start AND receive a call
                // before the wrapper has registered. If this happens
                // we should ask for call decoration for this call since
                // we denied sending the call decoration when the call
                // was fist detected (since the wrapper was not yet registered).
                const focusedActiveCall = getFocusedActiveCall(getState());
                if (focusedActiveCall) {
                    dispatch(handleNewCall(focusedActiveCall.get('key')));
                }

                break;
            }
        }
    }

    return result;
};
